<div class="card-header bg-transparent">
  <img src="assets/company-images/{{product.insuranceCompanyCode}}_large.jpg" style="width:200px;" />
</div>
<div class="card-body">
  <p>{{product.productName}}</p>
</div>
<div class="card-footer bg-transparent">
  <p>Eerstejaars premie<br /> {{product.premium | currency:'EUR'}}</p>
</div>